import { XXL, LG, XL } from "/constants/sizes";
import { WHITE_COLOR_NAME, BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
export const fullParagraphConfig = {
    title: "What’s new",
    topic: {
        text: ""
    },
    titleColor: WHITE_COLOR_NAME,
    titleSize: XXL,
    body: "Discover the latest feature releases, improvements, and updates on web, desktop and mobile apps.",
    bodyColor: WHITE_COLOR_NAME,
    textSize: LG,
    isFirstSegment: true
};
export const blackTextFullParagraphConfig = {
    title: "What’s new",
    topic: {
        text: ""
    },
    titleColor: BRAND_BLACK_TEXT_COLOR,
    titleSize: XL,
    body: "Discover the latest feature releases, improvements, and updates on web, desktop and mobile apps.",
    bodyColor: BRAND_BLACK_TEXT_COLOR,
    textSize: LG,
    isFirstSegment: true
};
export const assetConfig = {
    video: {
        src: {
            formats: [
                "/Generator_featured images/Whats new page/First_Fold-Whats_new.mp4"
            ]
        },
        loop: true,
        height: "480px"
    }
};
